// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.7.1_@swc+helpers@0.5.23__webpack@5.98.0_@swc+core@1.15._207d30a1a39a4eca1cd7ece3f0ffaa06/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.7.1_@swc+helpers@0.5.23__webpack@5.98.0_@swc+core@1.15._207d30a1a39a4eca1cd7ece3f0ffaa06/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
#    Colors
   ========================================================================== */
/*\$mainColor:#d40621;
\$alphaLight:rgba(#fff, .5);
\$alphaDark:rgba(#000, .5);
\$placeholderTextLight:rgba(#fff, .7);
\$placeholderTextDark:rgba(#000, .7);

\$textLight: #fff;
\$textDark: #404040;
\$textThemes:#d40621;*/
/* ################## */
/* ################## */
/* ################## */
/* ################## */
.wwrapper {
  position: fixed;
  top: 100px;
  right: 24px;
  z-index: 1;
}
.wwrapper .subContent {
  color: var(--c_textBody);
}
.wwrapper .content {
  color: var(--c_menuPublicTextColor);
}
.wwrapper .mainContent {
  color: var(--c_accentColor);
  font-size: 1.375em;
}
.wwrapper .subContent {
  color: var(--c_textBody);
  font-size: 0.875em;
}
.wwrapper .item {
  background: #fff;
  border-bottom: 5px solid var(--c_accentColor);
  min-width: 320px;
  min-height: 60px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  box-shadow: var(--cellula--elevation--floating);
  padding: 8px 16px;
}
.wwrapper .item .fill {
  fill: var(--c_accentColor);
}
.wwrapper .svgWrap {
  min-width: 30px;
  text-align: center;
  height: 27px;
  margin-right: 16px;
}
.wwrapper .svgWrap visiba-svg {
  width: auto;
}
.wwrapper .svgWrap visiba-svg svg {
  display: block;
  height: 27px;
}
.wwrapper .svgWrap span {
  color: var(--c_accentColor);
  font-weight: bold;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
